import React from "react";
import { useQuery } from "@apollo/client";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../App/Analytics";

import {
  FetchUserTawkOnlyPostsPaginatedV2,
  FetchUserAllPostsPaginatedV2,
  FetchUserPlaylistsV2,
} from "../../graphql/customWebappQueries/userProfileQueries";

import {
  FetchUserTawkOnlyPostsPaginatedQueryVariables,
  FetchUserTawkOnlyPostsPaginatedQuery,
  FetchUserAllPostsPaginatedQuery,
  FetchUserAllPostsPaginatedQueryVariables,
  FetchUserPlaylistsQuery,
  FetchUserPlaylistsQueryVariables,
  PostInfoV2Fragment,
  PostCollectionInfoV2Fragment,
} from "../../API";
import {
  LoadingView,
  ErrorView,
} from "../../Components/RecurringSmallViews/RecurringSmallViews";
import "../../Infrastucture/MissingStd";
import { PostCard } from "../../Components/PostCard/PostCard";
import {
  makePostCardConfig,
  makePlaylistCardConfig,
} from "../../Infrastucture/ComponentConfigBackendBridge";

import "./UserProfileLoadingLists.css";
import { PlaylistCard } from "../../Components/PlaylistCard/PlaylistCard";

export function UserTawkOnlyPosts(userSub: string): JSX.Element {
  logEvent(analytics, "screen_view", {
    firebase_screen: "UserProfile_TawksOnly",
    firebase_screen_class: "UserProfileLoadingLists",
    user_sub: userSub,
  });

  const { loading, error, data } = useQuery<
    FetchUserTawkOnlyPostsPaginatedQuery,
    FetchUserTawkOnlyPostsPaginatedQueryVariables
  >(FetchUserTawkOnlyPostsPaginatedV2, {
    errorPolicy: "ignore",
    variables: {
      userSub,
      nextPageToken: null,
    },
  });

  if (loading) {
    return LoadingView();
  }
  if (error) {
    return ErrorView();
  }

  const listPayload = data?.searchPosts;
  if (listPayload) {
    const postInfoItems = listPayload.items
      .tawkitExtensions()
      .compactMap((maybeItem) => {
        if (maybeItem) {
          const item: PostInfoV2Fragment = maybeItem;
          return item;
        }
        return null;
      });

    const postCards = postInfoItems.map((postInfo) => (
      <div className="PostList-PostCard-Wrapper">
        <PostCard key={postInfo.id} {...makePostCardConfig(postInfo)} />
      </div>
    ));

    return <div>{postCards}</div>;
  }

  return ErrorView("Unexpected.");
}

export function UserAllPosts(userSub: string): JSX.Element {
  logEvent(analytics, "screen_view", {
    firebase_screen: "UserProfile_UserAllPosts",
    firebase_screen_class: "UserProfileLoadingLists",
    user_sub: userSub,
  });

  const { loading, error, data } = useQuery<
    FetchUserAllPostsPaginatedQuery,
    FetchUserAllPostsPaginatedQueryVariables
  >(FetchUserAllPostsPaginatedV2, {
    errorPolicy: "ignore",
    variables: {
      userSub,
      nextPageToken: null,
    },
  });

  if (loading) {
    return LoadingView();
  }
  if (error) {
    return ErrorView();
  }

  const listPayload = data?.searchPosts;
  if (listPayload) {
    const postInfoItems = listPayload.items
      .tawkitExtensions()
      .compactMap((maybeItem) => {
        if (maybeItem) {
          const item: PostInfoV2Fragment = maybeItem;
          return item;
        }
        return null;
      });

    const postCards = postInfoItems.map((postInfo) => (
      <div className="PostList-PostCard-Wrapper">
        <PostCard key={postInfo.id} {...makePostCardConfig(postInfo)} />
      </div>
    ));

    return <div>{postCards}</div>;
  }

  return ErrorView("Unexpected.");
}

export function UserPlaylists(userSub: string): JSX.Element {
  logEvent(analytics, "screen_view", {
    firebase_screen: "UserProfile_UserPlaylists",
    firebase_screen_class: "UserProfileLoadingLists",
    user_sub: userSub,
  });

  const { loading, error, data } = useQuery<
    FetchUserPlaylistsQuery,
    FetchUserPlaylistsQueryVariables
  >(FetchUserPlaylistsV2, {
    errorPolicy: "ignore",
    variables: {
      userSub,
      nextPageToken: null,
    },
  });

  if (loading) {
    return LoadingView();
  }
  if (error) {
    return ErrorView();
  }

  const listPayload = data?.getUser?.postCollections;
  if (listPayload) {
    const items = listPayload.items
      .tawkitExtensions()
      .compactMap((maybeItem) => {
        if (maybeItem) {
          const item: PostCollectionInfoV2Fragment = maybeItem;
          return item;
        }
        return null;
      });

    const playlistCards = items.map((playlistInfo) => (
      <div>
        <div className="PlaylistList-PlaylistCard-Wrapper">
          <PlaylistCard
            key={playlistInfo.id}
            {...makePlaylistCardConfig(playlistInfo)}
          />
        </div>
        <hr style={{ margin: 0 }} />
      </div>
    ));

    return <div>{playlistCards}</div>;
  }

  return ErrorView("Unexpected.");
}
